import paginationBg from './pagination-bg.vue'

paginationBg.install = function(Vue) {
  Vue.component(paginationBg.name, paginationBg)
}

export default paginationBg
